import type { SectionDefinition } from './types';

/** Categories in first-seen order, each with its sections in registry order. Shared by the sidebar
 *  and the home page so the two group sections identically. */
export function groupByCategory(sections: SectionDefinition[]): Map<string, SectionDefinition[]> {
  const categories = new Map<string, SectionDefinition[]>();

  for (const section of sections) {
    if (section.category === null) continue;

    const items = categories.get(section.category);
    if (items) {
      items.push(section);
    } else {
      categories.set(section.category, [section]);
    }
  }

  return categories;
}
